import { render, staticRenderFns } from "./RelatedObject.vue?vue&type=template&id=19ad5968&"
import script from "./RelatedObject.vue?vue&type=script&lang=js&"
export * from "./RelatedObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports